import React, { useState } from 'react';
import './SyncButton.css';

const SyncButton = ({ userId = 1, onSyncComplete, customHandler, tooltipText = "Синхронизировать с ОРД" }) => {
  const [syncing, setSyncing] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleSync = async () => {
    setSyncing(true);
    setShowTooltip(false);
    
    try {
      // Если передан кастомный обработчик, используем его
      if (customHandler) {
        await customHandler();
        setSyncing(false);
        return;
      }
      
      // Иначе используем дефолтный (для договоров)
      const response = await fetch(`/api/contracts/sync-all?user_id=${userId}`, {
        method: 'POST'
      });
      const data = await response.json();
      
      if (onSyncComplete) {
        onSyncComplete(data);
      }
      
      // Показываем результат
      if (data.message) {
        window.alert(`✅ ${data.message}`);
      }
    } catch (error) {
      console.error('Ошибка синхронизации:', error);
      window.alert(`❌ Ошибка синхронизации`);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div 
      className="sync-icon-container"
      onMouseEnter={() => !syncing && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <button 
        className={`sync-icon-btn ${syncing ? 'spinning' : ''}`}
        onClick={handleSync}
        disabled={syncing}
        title={tooltipText}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.5 2V8H15.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C8.44413 3 5.38743 5.20193 4.11523 8.35815" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </button>
      {showTooltip && !syncing && (
        <div className="sync-tooltip">
          {tooltipText}
        </div>
      )}
      {syncing && (
        <div className="sync-tooltip syncing">
          Синхронизация...
        </div>
      )}
    </div>
  );
};

export default SyncButton;

